/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import sbp from '@sbp/sbp'
import { mapGetters, mapState } from 'vuex'
import { ACCEPTED_GROUP, OPEN_MODAL, PWA_INSTALLABLE } from '../../../frontend/utils/events.js'
import BannerSimple from '../../../frontend/views/components/banners/BannerSimple.vue'
import ButtonSubmit from '../../../frontend/views/components/ButtonSubmit.vue'
import RenderMessageWithMarkdown from '../../../frontend/views/containers/chatroom/chat-mentions/RenderMessageWithMarkdown.js'
import SvgCreateGroup from '../../../frontend/assets/svgs/create-group.svg'
import SvgJoinGroup from '../../../frontend/assets/svgs/join-group.svg'
import { ignoreWhenNavigationCancelled } from '../../../frontend/views/utils/misc.js'

const __vue_script__ = ({
  name: 'Home',
  components: {
    SvgJoinGroup,
    SvgCreateGroup,
    BannerSimple,
    ButtonSubmit,
    RenderMessageWithMarkdown
  },
  computed: {
    ...mapGetters([
      'currentIdentityState',
      'seenWelcomeScreen'
    ]),
    ...mapState([
      'currentGroupId'
    ]),
    isLoggedIn () {
      return !!this.$store.state.loggedIn
    }
  },
  data () {
    return {
      ephemeral: {
        serverMessages: [],
        seenWelcomeScreen: false,
        listener: ({ contractID }) => {
          if (contractID !== this.currentGroupId) return
          // For first time joins, force redirect to /pending-approval
          this.ephemeral.seenWelcomeScreen = false
        },
        showPwaPromo: false
      }
    }
  },
  beforeMount () {
    sbp('okTurtles.events/on', ACCEPTED_GROUP, this.ephemeral.listener)
    this.checkPwaInstallability()
    fetch(`${sbp('okTurtles.data/get', 'API_URL')}/serverMessages`).then(async (r) => {
      const data = await r.json()
      this.ephemeral.serverMessages = data.filter((msg) => msg.type === 'giHomeWarning').map((msg) => msg.message)
    }).catch(e => {
      console.error('[Home.vue] Error fetching or processing server announcements', e)
    })
  },
  mounted () {
    this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen
    if (this.isLoggedIn && this.currentGroupId) {
      this.navigateToGroupPage()
    } else if (this.$route.query.next) {
      this.openModal('LoginModal')
    }
  },
  destroyed () {
    sbp('okTurtles.events/off', ACCEPTED_GROUP, this.ephemeral.listener)
  },
  methods: {
    openModal (mode) {
      sbp('okTurtles.events/emit', OPEN_MODAL, mode)
    },
    navigateToGroupPage () {
      // NOTE:
      // When browser refresh is triggered, there is an issue that Vue router prematurely decides ('loginGuard' there) that
      // the user is not signed in when in actual reality user-login is still being processed and then
      // takes user to 'Home.vue' with the '$route.query.next' being set to the initial url.
      // In this particular condition, the app needs to immediately redirect user to '$route.query.next'
      // so that the user stays in the same page after the browser refresh.
      // (Related GH issue: https://github.com/okTurtles/group-income/issues/1830)
      const path = this.$route.query.next ?? (this.ephemeral.seenWelcomeScreen ? '/dashboard' : '/pending-approval')
      this.$router.push({ path }).catch(e => ignoreWhenNavigationCancelled(e, path))
    },
    checkPwaInstallability () {
      this.ephemeral.showPwaPromo = sbp('service-worker/check-pwa-installability')
      sbp('okTurtles.events/once', PWA_INSTALLABLE, () => {
        this.ephemeral.showPwaPromo = true
      })
    },
    async onInstallClick () {
      await sbp('service-worker/trigger-install-prompt')
    }
  },
  watch: {
    currentGroupId (to) {
      // Redirect to `/pending-approval` if our profile isn't active or the
      // welcome screen hasn't been approved
      this.ephemeral.seenWelcomeScreen = this.seenWelcomeScreen
      if (to && this.isLoggedIn) {
        this.navigateToGroupPage()
      }
    },
    isLoggedIn (to) {
      if (to && this.currentGroupId) {
        this.navigateToGroupPage()
      }
    }
  }
}        )

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.currentGroupId)?_c('main',{staticClass:"c-splash",attrs:{"data-test":"homeLogo"}},[(!_vm.isLoggedIn)?_c('header',{key:"title-login"},[_c('img',{staticClass:"logo",attrs:{"src":"/assets/images/group-income-icon-transparent.png"}}),_c('i18n',{staticClass:"is-title-1",attrs:{"tag":"h1","data-test":"welcomeHome"}},[_vm._v("Welcome to Group Income")])],1):_c('header',{key:"title-not-login"},[_c('img',{staticClass:"logo-2",attrs:{"src":"/assets/images/logo-transparent.png"}}),_c('i18n',{staticClass:"is-subtitle",attrs:{"tag":"p"}},[_vm._v("Welcome to Group Income")]),_c('i18n',{staticClass:"is-title-1",attrs:{"tag":"h1","data-test":"welcomeHomeLoggedIn"}},[_vm._v("Let’s get this party started")])],1),(!_vm.isLoggedIn)?_c('div',{key:"body-loggin",staticClass:"buttons"},[_c('i18n',{ref:"loginBtn",attrs:{"tag":"button","data-test":"loginBtn"},on:{"click":function($event){return _vm.openModal("LoginModal")}}},[_vm._v("Login")]),_c('i18n',{directives:[{name:"focus",rawName:"v-focus"}],ref:"signupBtn",attrs:{"tag":"button","data-test":"signupBtn"},on:{"click":function($event){return _vm.openModal("SignupModal")},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.openModal("SignupModal")}}},[_vm._v("Signup")])],1):_c('div',{key:"body-create",staticClass:"create-or-join"},[_c('div',{staticClass:"card"},[_c('svg-create-group'),_c('i18n',{staticClass:"is-title-3",attrs:{"tag":"h3"}},[_vm._v("Create")]),_c('i18n',{attrs:{"tag":"p"}},[_vm._v("Create a new group and invite your friends.")]),_c('i18n',{attrs:{"tag":"button","data-test":"createGroup","aria-label":_vm.L("Add a group")},on:{"click":function($event){return _vm.openModal("GroupCreationModal")}}},[_vm._v("Create Group")])],1),_c('div',{staticClass:"card"},[_c('svg-join-group'),_c('i18n',{staticClass:"is-title-3",attrs:{"tag":"h3"}},[_vm._v("Join")]),_c('i18n',{attrs:{"tag":"p"}},[_vm._v("Enter an existing group using your username.")]),_c('i18n',{attrs:{"tag":"button","data-test":"joinGroup"},on:{"click":function($event){return _vm.openModal("GroupJoinModal")}}},[_vm._v("Join a Group")])],1)]),(!_vm.isLoggedIn && _vm.ephemeral.showPwaPromo)?_c('banner-simple',{staticClass:"hide-hoverable-device hide-tablet c-pwa-promo",attrs:{"severity":"general"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('i18n',[_vm._v("Install this web app on your device for better usability.")])]},proxy:true}],null,false,1382767684)},[_c('button-submit',{staticClass:"is-success is-small c-install-btn",attrs:{"type":"button"},on:{"click":_vm.onInstallClick}},[_vm._v(_vm._s(_vm.L('Install')))])],1):_vm._e(),(!_vm.isLoggedIn && _vm.ephemeral.serverMessages.length > 0)?_c('footer',{staticClass:"c-footer"},_vm._l((_vm.ephemeral.serverMessages),function(text){return _c('banner-simple',{staticClass:"c-demo-warning",attrs:{"severity":"warning"}},[_c('render-message-with-markdown',{attrs:{"text":text}})],1)}),1):_vm._e()],1):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-2fc59f2f_0", { source: ".c-splash[data-v-2fc59f2f]{display:flex;flex-direction:column;text-align:center;align-items:center;min-height:100%}@media screen and (min-width:769px),print{.c-splash[data-v-2fc59f2f]{justify-content:center}}.logo[data-v-2fc59f2f]{width:8rem;margin:2rem auto}.logo-2[data-v-2fc59f2f]{width:8rem;margin:0 auto 3rem auto}@media screen and (min-width:769px),print{.logo-2[data-v-2fc59f2f]{margin:0;position:absolute;left:1.5rem;top:1.5rem}}@media screen and (min-width:769px),print{.is-subtitle[data-v-2fc59f2f]{margin-top:3rem}}@media screen and (min-width:1200px){.is-subtitle[data-v-2fc59f2f]{margin-top:0}}.buttons[data-v-2fc59f2f]{min-width:230px}.create-or-join[data-v-2fc59f2f]{display:flex;width:100%;flex-wrap:wrap;margin-top:.5rem;justify-content:center;text-align:left}@media screen and (min-width:769px),print{.create-or-join[data-v-2fc59f2f]{text-align:center}}.card[data-v-2fc59f2f]{margin:1.5rem 1.5rem 0 1.5rem;width:100%}@media screen and (min-width:769px),print{.card[data-v-2fc59f2f]{width:24.375rem}}.card h3[data-v-2fc59f2f]{margin-bottom:.25rem}.card svg[data-v-2fc59f2f]{width:6rem;margin-left:1rem;float:right}@media screen and (min-width:769px),print{.card svg[data-v-2fc59f2f]{float:none;width:9.75rem;margin:2.5rem auto 1.5rem auto}}.card .button[data-v-2fc59f2f]{margin-top:2rem}@media screen and (min-width:769px),print{.card .button[data-v-2fc59f2f]{margin-bottom:1rem}}.c-footer[data-v-2fc59f2f]{margin-top:2.25rem;padding:0 1rem;max-width:31.25rem}.c-demo-warning[data-v-2fc59f2f]{text-align:start;margin-block-end:1rem}.c-pwa-promo[data-v-2fc59f2f]{position:fixed;bottom:1.875rem;left:50%;transform:translateX(-50%);z-index:10;text-align:left;width:calc(100vw - 3rem);max-width:31.25rem}.c-pwa-promo[data-v-2fc59f2f]  .c-body{margin-top:1rem;text-align:right}.c-install-btn[data-v-2fc59f2f]{padding-left:1.75rem;padding-right:1.75rem}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-2fc59f2f"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__